import {
    FETCH_DELETION_REQUESTS,
    PROCESS_DELETION_REQUEST,
    DELETION_REQUESTS_LOADING,
} from "../constants/actionTypes";

const initialState = {
    requests: [],
    isLoading: false,
};

const deletionRequestsReducer = (state = initialState, action) => {
    switch (action.type) {
        case DELETION_REQUESTS_LOADING:
            return { ...state, isLoading: true };

        case FETCH_DELETION_REQUESTS:
            return { ...state, requests: action.payload, isLoading: false };

        // Remove from local list after processing (UI refreshes from server)
        case PROCESS_DELETION_REQUEST:
            return {
                ...state,
                requests: state.requests.filter((r) => r._id !== action.payload),
            };

        default:
            return state;
    }
};

export default deletionRequestsReducer;
